








































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  VerificationStatus,
  VerificationStatusName,
  LeadEventTypes
} from "@/lib/logEvent";
import moment from "moment";
import { collections, firestore } from "@/configs/firebase";
import logger from "@/configs/logger";
import { throttle } from "lodash";
import { objectify } from "@/helpers";
import VuetifyAudio from "@/components/VuetifyAudio.vue";
import * as api from "@/lib/api";

@Component({ components: { VuetifyAudio } })
export default class EventTimeLine extends Vue {
  @Prop({ required: true }) lead!: any;
  @Prop({ default: "verification_status" }) eventType!: LeadEventTypes;

  audioDialog = false;
  audioLink: string = "";

  events: VerificationStatus[] = [];
  unsubscribeEvents!: Function;

  get items(): any[] {
    return this.events.map((event: VerificationStatus) => {
      return {
        color: this.getEventColor(event.name),
        // @ts-ignore
        time: moment.unix(event.created_ts.seconds).fromNow(),
        snippedRecordingKey: event.snipped_recording_key,
        ...event
      };
    });
  }

  mounted(): void {
    this.observeVerificationEvents();
  }

  beforeDestroy(): void {
    this.unsubscribeEvents();
  }

  async snipRecording(snippedRecordingKey: string) {
    try {
      const resp = await api.getSnippedRecordingDownloadLink(
        snippedRecordingKey
      );
      this.audioLink = resp.data;
      this.audioDialog = true;
    } catch (err) {
      logger("error", "snip recording error", err);
    }
  }

  observeVerificationEvents(): void {
    this.unsubscribeEvents = collections.lead
      .doc(this.lead.id)
      .collection("event")
      .where("event_type", "==", this.eventType)
      .orderBy("created_ts", "desc")
      .limit(10)
      .onSnapshot(throttle(this.handleSnapshotChange, 500, { leading: true }));
  }

  handleSnapshotChange(snapshot: firestore.QuerySnapshot): void {
    this.events = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as any;
    const docChanges = snapshot.docChanges();
    const change = docChanges[docChanges.length - 1];
    if (objectify(change).type === "added") {
      this.notifyOnNewEvent(change.doc.data());
    }
  }

  notifyOnNewEvent(event: any): void {
    logger("log", event);
    // we only want to show notification for non "request" events.
    if (event && event.name !== "requested") {
      this.$toasted
        .info(`${event.verification_type} ${event.name}`)
        .goAway(2000);
    }
  }

  getEventColor(eventName: VerificationStatusName): string {
    switch (eventName) {
      case "requested":
        return "pink";
      case "received":
        return "success";
      case "sent":
        return "primary";
      case "started":
        return "teal";
      case "stopped":
        return "secondary";
      default:
        return "secondary";
    }
  }
}
